export default __webpack_public_path__ + "static/pragicts-our-perspectives-banner-context-matters-da138a0ce961df0e3224595a9ae605ef.jpg";